import React from "react";
import { ProjectList } from "./subPages/ProjectList";
import { useProjectContext } from "./context";
import { projectOperationsList } from "./constants/project.constants";
import { PreviewProject } from "./subPages/PreviewProject";
import { ProjectTask } from "./subPages/ProjectTask";
import { UpdateProject } from "./subPages/UpdateProject";

export const ProjectPage = () => {
  const { currentOperationPage } = useProjectContext();

  return (
    <>
      {currentOperationPage === projectOperationsList.listProject && (
        <ProjectList />
      )}
      {currentOperationPage === projectOperationsList.previewProject && (
        <PreviewProject />
      )}
      {currentOperationPage === projectOperationsList.projectTask && (
        <ProjectTask />
      )}
      {currentOperationPage === projectOperationsList.updateProject && (
        <UpdateProject />
      )}
    </>
  );
};
